import { useGameTime } from "../../../redux/gameTime";
import styles from "./Player.module.css";
import Time from "./Time";

export default function OpponentTime({ isRunning }) {
  const { opponentTime } = useGameTime();

  return (
    <div className={styles.timeContainer}>
      <Time time={opponentTime} isRunning={isRunning} />
    </div>
  );
}
